import { useLang } from 'hooks/lang';

import { loaders, BUG_REPORT_SEVERITIES } from 'entities';

import { Column, IconButton, Skeleton } from 'components/Blocks';
import { GoBackButton } from 'components/Buttons';
import { RefreshIcon, ZeroDataIcon } from 'components/Icons';

import { BugReportCard } from './ReportCard';

import { findIndexOrNull, listPartialUpdate, sortByProperty } from 'utils/array';

export default function BugReports() {
  const { t } = useLang();

  const bugReports = loaders.feedback.openBugReports.use({
    defaultValue: [],

    parser: (suggestions) =>
      sortByProperty(suggestions, ['severity', 'timestamp'], {
        severity: (a, b) =>
          findIndexOrNull(BUG_REPORT_SEVERITIES, a, 'value')! -
          findIndexOrNull(BUG_REPORT_SEVERITIES, b, 'value')!,
      }),

    refreshMinutes: 1,
  });

  if (bugReports.errorOrLoading) return <Skeleton quantity={8} height={42} />;

  return (
    <>
      <Column>
        <Column gap="2">
          <h5 className="flex items-center gap-2 text-3xl font-medium text-primary">
            <GoBackButton />
            {t('bug-reports')}
            <IconButton size="small" onClick={bugReports.retry}>
              <RefreshIcon size={14} />
            </IconButton>
          </h5>
        </Column>

        {bugReports.data.length ? (
          <Column>
            {bugReports.data.map((report) => (
              <BugReportCard
                key={report.id}
                report={report}
                updateReport={(updateProps) =>
                  bugReports.overwrite((old) =>
                    listPartialUpdate(old, { ...updateProps, id: report.id }),
                  )
                }
              />
            ))}
          </Column>
        ) : (
          <Column gap="2" alignItems="center" className="p-2">
            <ZeroDataIcon size={36} color="primary" />

            <p className=" font-medium">No data found</p>
          </Column>
        )}
      </Column>
    </>
  );
}
